import { Button } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

interface ButtonNewProductProps {
  setProductsCreateUpdateModal: React.Dispatch<React.SetStateAction<boolean>>
}

const ButtonNewProduct = ({
  setProductsCreateUpdateModal,
}: ButtonNewProductProps) => {
  const { t } = useTranslation()

  return (
    <Button
      onClick={() => {
        setProductsCreateUpdateModal(true)
      }}
      label={t('New product')}
      buttonType="button"
      type="action"
      size="md"
    />
  )
}

export default ButtonNewProduct
